import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { formMessage } from '../interfaces/landing-page.interface';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class LandingPageService {
  http = inject(HttpClient);
  router = inject(Router);
  constructor() { }

  sendMessage(formMessage: formMessage): Observable<formMessage> {

    const params = new HttpParams().set('system', this.router.url);

    return this.http.post<formMessage>(`${environment.api}/api/form-suport/create-suport-by-form-response`, formMessage, { params, responseType: 'text' as 'json' });
    
  }
}
